<template>
  <div class="flex align-items-center saler-list-cell">
    <SalerAvatar :name="data.caName" />
    <div class="saler-info c:col-between-start">
      <p class="saler-name">
        {{ data.caName }}
      </p>
      <p class="saler-info-item">
        <span>总销售订单：{{ data.salesOrderCount }}</span>
        <span class="saler-total-amount"
          >总销售金额：￥ {{ formattedPrice }}</span
        >
      </p>
      <p class="saler-info-item">最后销售时间：{{ formattedTime }}</p>
    </div>
  </div>
</template>
<script>
import { outputmoney } from "@/utils";
import SalerAvatar from "./SalerAvatar.vue";

export default {
  components: { SalerAvatar },
  props: { data: Object },
  computed: {
    formattedPrice() {
      return outputmoney(this.data?.salesAmount || 0);
    },
    formattedTime() {
      return this.data?.lastSalesTime
        ? this.$moment(this.data.lastSalesTime).format("YYYY-MM-DD HH:mm:ss")
        : "";
    },
  },
};
</script>
<style lang="less" scoped>
.saler-list-cell {
  gap: 8/20rem;

  box-sizing: border-box;
  width: 100%;
  height: 97/20rem;
  padding: 35/40rem 40/40rem;
  border-top: 1/20rem solid #fff;
  border-bottom: 3/20rem solid #e8e8e8;
  background: #fff;

  &:first-child {
    border-top: 1/20rem solid #e8e8e8;
  }

  .saler-info {
    flex: 1;
    height: 62/20rem;

    .saler-name {
      height: 20/20rem;
      line-height: 20/20rem;
      font-size: 14/20rem;
      font-weight: 500;
      color: #000;
    }

    .saler-info-item {
      height: 17/20rem;
      line-height: 17/20rem;
      font-size: 12/20rem;
      color: #7d7d7d;

      .saler-total-amount {
        margin-left: 14/20rem;
      }
    }
  }
}
</style>
